import { format } from "date-fns";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export const JobDate = ({ uploadedAt }: { uploadedAt: Date }) => {
  return (
    <div className="flex-6 pl-[0.75rem]">
      <span
        className="hidden lg:inline truncate text-nowrap"
        data-testid="job-date-full"
      >
        {format(uploadedAt, "PPP p")}
      </span>
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <div>
              <span
                className="hidden md:inline lg:hidden truncate text-nowrap"
                data-testid="job-date-medium"
              >
                {format(uploadedAt, "PPP")}
              </span>
              <span
                className="inline md:hidden truncate text-nowrap"
                data-testid="job-date-short"
              >
                {format(uploadedAt, "MMMM d")}
              </span>
            </div>
          </TooltipTrigger>
          <TooltipContent>
            <p>{format(uploadedAt, "PPP p")}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
